import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import LanguageIcon from './LanguageIcon';
import BelgiumFlag from './asset/BelgiumIcon';
import FranceFlag from './asset/FranceIcon';

const languages = {
    fr: {
        name: 'France',
        nativeName: 'France',
        shortcut: 'FR',
        icon: <FranceFlag />,
    },
    be_FR: {
        name: 'Bruxelles',
        nativeName: 'Bruxelles',
        shortcut: 'FR',
        icon: <BelgiumFlag />,
    },
    be_NL: {
        name: 'Bruxelles',
        nativeName: 'Brussel',
        shortcut: 'NL',
        icon: <BelgiumFlag />,
    },
};

const LanguageSwitcher = () => {
    const [showMenu, setShowMenu] = useState(false);
    const styles = useStyles();
    const { i18n } = useTranslation();
    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setShowMenu(false);
        window.location.reload(); // for now, refresh page, for everything to be reloaded. Next step is to make class functionalComponents so that we can use hooks and not reload the page
    };
    return (
        <div
            style={styles.languageSwitcherStyle}
            onClick={() => setShowMenu(!showMenu)}
        >
            <LanguageIcon currentLanguage={languages[i18n.language]} />
            {showMenu && (
                <ul style={styles.languageMenuStyle}>
                    {Object.entries(languages).map(
                        ([code, { icon, name, nativeName, shortcut }]) => (
                            <div style={styles.languageIconStyle}>
                                <i style={styles.globeIconStyle}>{icon}</i>{' '}
                                {/* Replace with an actual icon */}
                                <li
                                    style={styles.languageMenuItemStyle}
                                    key={code}
                                    onClick={() => changeLanguage(code)}
                                >
                                    {nativeName} | {shortcut}
                                </li>
                            </div>
                        )
                    )}
                </ul>
            )}
        </div>
    );
};

const useStyles = () => {
    return {
        languageIconStyle: {
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            padding: '0px 10px 0px 10px',
        },
        globeIconStyle: {
            marginRight: '5px',
        },
        languageSwitcherStyle: {
            position: 'relative',
            cursor: 'pointer',
            padding: '0px 10px 0px 10px',
        },
        languageMenuStyle: {
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '5px',
            padding: '5px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            listStyle: 'none',
        },
        languageMenuItemStyle: {
            padding: '5px 10px',
            cursor: 'pointer',
            color: 'rgba(0,0,0,0.6)',
            fontSize: '12px',
            whiteSpace: 'nowrap',
        },
    };
};

export default LanguageSwitcher;
